var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
var HeroSlider = require('components/hero-slider');

function PageHeroSlider(el) {
  this.$el = $(el);

  var $parentModule = this.$el.parent().closest('[data-module]');

  if($parentModule.length) {
    return;
  }

  this.$indicators = this.$el.find('[data-slide-indicator]');
  this.slider = new HeroSlider(this.$el[0], this.$indicators);
}

module.exports = PageHeroSlider;